import { render, staticRenderFns } from "./projectAdd.vue?vue&type=template&id=3b0e17da&scoped=true&"
import script from "./projectAdd.vue?vue&type=script&lang=js&"
export * from "./projectAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e17da",
  null
  
)

export default component.exports